navApp.factory 'getNavBranchItemsWithCallouts', [ '_', (_) ->
  flattenRecursiveChildren = (items) ->
    _.reduce items, (memo, item) ->
      memo.push item
      out = memo
      if _.size(item.children) > 0
        flattened = flattenRecursiveChildren item.children
        out = out.concat flattened
      out
    , []


  (branch) ->
    _.reject (flattenRecursiveChildren branch), (item) ->
      _.size(item.callout) == 0
]
